import { v4 as uuidv4 } from 'uuid';
// Types
import { ChannelType } from '@trii/types/dist/Common/Channels';

export interface NewAddress {
  id: string;
  address: string;
  note: string;
  channelType:
    | ChannelType.PHONE
    | ChannelType.EMAIL
    | ChannelType.WHATSAPP
    | ChannelType.INSTAGRAM
    | ChannelType.RCS;
  isSaved: boolean;
}


function createNewAddress(
  channelType: ChannelType.PHONE | ChannelType.EMAIL | ChannelType.WHATSAPP | ChannelType.RCS
): NewAddress {
  return {
    id: uuidv4(),
    address: '',
    note: '',
    channelType,
    isSaved: false,
  };
}

export default { createNewAddress };
